import { render, staticRenderFns } from "./RecommendedLearning.vue?vue&type=template&id=3d6be5b7&scoped=true"
import script from "./RecommendedLearning.vue?vue&type=script&lang=js"
export * from "./RecommendedLearning.vue?vue&type=script&lang=js"
import style0 from "./RecommendedLearning.vue?vue&type=style&index=0&id=3d6be5b7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6be5b7",
  null
  
)

export default component.exports